export default __webpack_public_path__ + "static/media/f_videolist.7d9917af.svg";